import { Component } from "@angular/core";

@Component({
    selector: "progress-storybook",
    templateUrl: "./progress-storybook.component.html",
})
export class ProgressStorybookComponent {}
